import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Package = ({ room }) => {
    // destructure room
    const { id, name, image, description, price } = room;
    const { t } = useTranslation();

    return (
      <div className='bg-white shadow-2xl min-h-[380px] group lg:w-1/5 mb-5 lg:mb-0'>
        {/* img */}
        <div className='overflow-hidden'>
          <img
            className='group-hover:scale-110 transition-all duration-300 w-full lg:max-w-[400px]'
            src={image}
            alt=''
          />
        </div>
        {/* details */}
        <div className='text-center'>
          <Link to={`/room/${id}`}>
            <h3 className='h3'>{name}</h3>
          </Link>
          <p className='lg:max-w-[350px] mx-auto mb-3 lg:mb-6'>
            {description.slice(0, 100)}
          </p>
        </div>
        {/* btn */}
        <button
          // to={`/room/${id}`}
          className='btn btn-secondary btn-sm lg:max-w-[250px] mx-auto'
        >
           {t('ZarezerwujOd')} {price}
        </button>
      </div>
    );
  };

export default Package